import { datadogRum } from "@datadog/browser-rum";
import { getEnvironment } from "../../Config/utils/enviroment";

export const setupDatadog = () => {
  datadogRum.init({
    applicationId: "5676abc7-dbf7-4ace-9f03-a5040500d3ed",
    clientToken: "pub7301ffe077c7c4de6bbfe7817d8283a1",
    site: "us5.datadoghq.com",
    service: "web",
    env: getEnvironment() === "prod-au" ? "production" : "development",
    trackSessionAcrossSubdomains: true,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      "https://api.dapple.dev",
      "https://api-au.dapplecrm.com",
      "https://app-au.dapplecrm.com",
      "https://localhost:3000",
    ],
  });
};
